module.exports = __webpack_public_path__ + "static/img/logo_zlc.05d3f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_zlc.png
// module id = k82s
// module chunks = 0